"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.config.title': 'Konfiguracja Treningu',
    'trainer.config.basic': 'Ustawienia Podstawowe',
    'trainer.config.model.name': 'Nazwa Modelu',
    'trainer.config.model.name.required': 'Nazwa Modelu *',
    'trainer.config.model.name.placeholder': 'Wprowadź unikalną nazwę dla swojego modelu',
    'trainer.config.base.model': 'Model Bazowy',
    'trainer.config.fine.tuning': 'Wybierz metodę trenowania',
    'trainer.config.fine_tuning.lora_extension': 'Rozszerzenie LoRA',
    'trainer.config.fine_tuning.fulltrain': 'Pełny Trening',
    'trainer.config.advanced': 'Ustawienia Zaawansowane',
    'trainer.config.advanced.hide': 'Ukryj',
    'trainer.config.advanced.show': 'Pokaż',
    'trainer.config.epochs': 'Epoki',
    'trainer.config.epochs.help': 'Liczba iteracji treningu (zalecane: 10-50)',
    'trainer.config.learning.rate': 'Współczynnik Uczenia',
    'trainer.config.learning.rate.help': 'Kontroluje jak szybko model się uczy (zalecane: 0.001)',
    'trainer.config.batch.size': 'Rozmiar Partii',
    'trainer.config.batch.size.help': 'Liczba próbek przetwarzanych razem',
    'trainer.config.validation.split': 'Podział Walidacji',
    'trainer.config.validation.split.help': 'Procent danych używanych do walidacji (0.2 = 20%)',
    'trainer.config.train': 'Rozpocznij Trening',
};
